import { Injectable } from '@angular/core';
import { Headers, Http, RequestOptions, Response } from '@angular/http';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class StringTableService {

  private decodedStringTable: any;

  private endPoints: any;

  allowGetReq: boolean;

  constructor(private http: Http) {
    this.allowGetReq = true;
  }

  setLocalisationStrings(localizationStrings: Object) {
    this.decodedStringTable = localizationStrings;
  }

  getTrainingManagementMenuData() {
    return this.decodedStringTable.trainingManagement;
  }

  getString(primaryKey: string, secondaryKey: string): string {
    return this.decodedStringTable[primaryKey][secondaryKey];
  }

  getArrayOfStrings(primaryKey: string, secondaryKey: string): string[] {
    return this.decodedStringTable[primaryKey][secondaryKey];
  }
  /**
   *
   * @param testType The type of the test for which you want the scaling info.
   */
  getScalingNumbers(testType: string) {
    return this.decodedStringTable['scaleValues'][testType];
  }

  /**
   *
   * @param key the endpoint key
   */
  getEndpoint(key) {
    return this.endPoints[key];
  }

  setEndPoints(endPoints) {
    this.endPoints = endPoints;
  }


}



// WEBPACK FOOTER //
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/services/string-table.service.ts